import { Map, MapMarker, MarkerContent, MarkerLabel } from '@components/ui/map';

export type Hood = { name: string; lng: number; lat: number; home?: boolean };

/** Live street map of the Star-Revue coverage area, with a pin per neighborhood. Red Hook is the home pin. */
export function CoverageMap({ hoods }: { hoods: Hood[] }) {
  return (
    <Map theme="light" viewport={{ center: [-73.997, 40.683], zoom: 12.6 }} className="h-full w-full">
      {hoods.map((h) => (
        <MapMarker key={h.name} longitude={h.lng} latitude={h.lat}>
          <MarkerContent>
            {h.home
              ? <div className="h-5 w-5 rounded-full border-[3px] border-background bg-[hsl(var(--headline-red))] shadow-[0_2px_6px_hsl(220_40%_8%/0.4)]" />
              : <div className="h-3 w-3 rounded-full border-2 border-background bg-[hsl(var(--brand-blue))] shadow-[0_1px_4px_hsl(220_40%_8%/0.35)]" />}
          </MarkerContent>
          <MarkerLabel className={h.home ? 'bg-[hsl(var(--headline-red))] px-1.5 py-0.5 text-xs font-extrabold uppercase tracking-wider text-background' : 'bg-background/90 px-1 text-[11px] font-bold text-foreground'}>{h.name}</MarkerLabel>
        </MapMarker>
      ))}
    </Map>
  );
}
